import React from 'react';
import PropTypes from 'prop-types';
import Countdown, { zeroPad } from 'react-countdown-now';
import { Link } from 'react-router-dom';
import Prize from 'containers/Auctions/components/Prize';
import TimeSync from 'utils/TimeSync';
import TimeSyncWrapper from 'utils/TimeSync/TimeSyncWrapper';
import { formatDate } from 'utils/formatting';
import { withDrawingCountdown } from '../utils/withDrawingCountdown';
import './DrawingCard.css';

const DrawingCard = ({ drawing, onAction }) => {
  const status = drawing.drawingState;
  const hasStarted = status === 'Upcoming' ? false : true;
  const { totalEntries, totalParticipants, description, name, id, drawTime } =
    drawing;
  const prizes =
    drawing.winningPlaces &&
    drawing.winningPlaces.winningPlaces.map(place => place.prize);

  const renderDrawingFooter = (id, drawTime, hasStarted) => {
    const countdownRenderer = ({ days, hours, minutes, seconds }) => {
      const totalHours = days ? days * 24 + hours : hours;
      return `Draw In: ${zeroPad(totalHours)}:${zeroPad(minutes)}:${zeroPad(
        seconds
      )}`;
    };
    const buttonText = hasStarted ? 'Join' : 'View';

    return (
      <div className="drawing-footer">
        <div className="countdown-container">
          {!hasStarted ? (
            <Countdown
              date={TimeSync.toLocalTime(drawTime)}
              renderer={countdownRenderer}
            />
          ) : (
            'Drawing In Progress'
          )}
        </div>
        {onAction && (
          <Link className="drawing-button" to={`/drawings/${id}`}>
            {buttonText}
          </Link>
        )}
      </div>
    );
  };

  return (
    <div className={`drawing ${hasStarted ? ' active' : ''}`}>
      <Prize prizes={prizes} />
      <div className="drawing-info">
        <div className="draw-date">{formatDate(drawTime, 'fullCompact')}</div>
        <div className="name">{name}</div>
        <div className="description">{description}</div>
        <div className="online-entries">Online Entries: {totalEntries}</div>
        <div className="participants">
          {`${totalParticipants} ${
            totalParticipants === 1 ? 'participant' : 'participants'
          }`}
        </div>
        {renderDrawingFooter(id, drawTime, hasStarted)}
      </div>
    </div>
  );
};

DrawingCard.propTypes = {
  drawing: PropTypes.object,
  onAction: PropTypes.func
};

export default TimeSyncWrapper(withDrawingCountdown(DrawingCard));
